var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 140,
    viewBox: "0 0 180 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1410086646"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624297",
    x: 8,
    y: 22,
    width: 157,
    height: 103,
    rx: 22,
    fill: "#FFE5DF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2554",
    x: 141,
    y: 14,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FB6E4F"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 117",
    d: "M150.414 23.4136L163.591 36.59",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 118",
    d: "M163.586 23.4136L150.409 36.59",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005404"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624310",
    x: 54,
    y: 40,
    width: 66,
    height: 66,
    rx: 16,
    fill: "#19184A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005389"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34624149",
    d: "M69.3047 83.9358C69.3047 78.4129 73.7818 73.9358 79.3047 73.9358H95.6525C101.175 73.9358 105.653 78.4129 105.653 83.9358V89.7392H69.3047V83.9358Z",
    fill: "#558BFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 67",
    cx: 87.477,
    cy: 62.0832,
    r: 8.69187,
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfie);
export default __webpack_public_path__ + "static/media/selfie.ae233ef61847d1c56c4106ba1231136e.svg";
export { ForwardRef as ReactComponent };